exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__image___oF2Io{max-width:200px;margin:0 auto;display:flex;justify-content:center}.Top-module__title___1h6Vg{display:grid}", ""]);

// exports
exports.locals = {
	"image": "Top-module__image___oF2Io",
	"title": "Top-module__title___1h6Vg"
};